import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 16C5 14.3431 6.34315 13 8 13H12C13.6569 13 15 14.3431 15 16L10 17.5L5 16Z",
			fill: "#0517F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.8025 15.7585L14.5108 15.026C14.3633 14.6543 14.1342 14.321 13.8408 14.0493L13.7875 14.0002C13.3258 13.5718 12.7192 13.3335 12.0892 13.3335H7.91082C7.28082 13.3335 6.67416 13.5718 6.21166 13.9993L6.15832 14.0493C5.86499 14.321 5.63666 14.6543 5.48832 15.026L5.19666 15.7585",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.0623 6.20584C13.2014 7.34487 13.2014 9.1916 12.0623 10.3306C10.9233 11.4697 9.07656 11.4697 7.93753 10.3306C6.79849 9.1916 6.79849 7.34487 7.93753 6.20584C9.07656 5.0668 10.9233 5.0668 12.0623 6.20584Z",
			fill: "#0517F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0623 6.20584C13.2014 7.34487 13.2014 9.1916 12.0623 10.3306C10.9233 11.4697 9.07656 11.4697 7.93753 10.3306C6.79849 9.1916 6.79849 7.34487 7.93753 6.20584C9.07656 5.0668 10.9233 5.0668 12.0623 6.20584",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3033 4.6967C18.2322 7.62563 18.2322 12.3744 15.3033 15.3033C12.3744 18.2322 7.62562 18.2322 4.6967 15.3033C1.76777 12.3744 1.76777 7.62562 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgContactsActive;
